import { createReducer } from 'utils/reduxUtils';
import set from 'lodash/fp/set';
import flow from 'lodash/fp/flow';
import * as Status from 'constants/statuses';
import {
  FETCH_PRODUCTS_FAILURE,
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCTS_SUCCESS,
} from './actionTypes';

import initialState from './initialState';

const reducerToActionTypeMap = {
  [FETCH_PRODUCTS_REQUEST]: set('productsStatus', Status.LOADING),
  [FETCH_PRODUCTS_SUCCESS]: (state, { payload }) =>
    flow(set('productsStatus', Status.SUCCESS), set('fetchedProducts', payload))(state),
  [FETCH_PRODUCTS_FAILURE]: set('productsStatus', Status.ERROR),
};

export default createReducer(reducerToActionTypeMap, initialState);
